<template>
  <v-container fluid>
    <v-toolbar
      flat
      class="toolbar--white get-height action-bar hidden-xs--block"
      :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    >
      <Breadcrumb :routes="breadcrumbItems" />
      <v-spacer></v-spacer>
    </v-toolbar>

    <div class="page-content">
      <header class="page-header">
        <h1 class="page-title">{{ $t(`${namespace}.title`) }}</h1>
        <p class="page-desc">{{ $t(`${namespace}.pageDescription`) }}</p>
      </header>

      <div class="page-body">
        <profile-card-list
          :profiles="profiles"
          @addEmployees="openDrawer"
        />
      </div>
    </div>

    <access-profiles-drawer
      :show="drawer"
      @closeDrawer="closeDrawer"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import Breadcrumb from 'components/Breadcrumb'
import ProfileCardList from 'components/accessProfiles/ProfileCardList'
import AccessProfilesDrawer from 'components/accessProfiles/accessProfilesDrawer'

export default {
  name: 'AccessProfilesPage',
  components: {
    Breadcrumb,
    ProfileCardList,
    AccessProfilesDrawer
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: state => state.mainMenu.isOpen
    })
  },
  data () {
    return {
      namespace: 'Views.AccessProfilesPage',
      breadcrumbItems: [
        { name: '', title: 'Admin' },
        { name: 'AccessProfilesPage', title: this.$t('Views.AccessProfilesPage.title') }
      ],
      drawer: false,
      profiles: [
        {
          name: 'Owner (SU)',
          id: 1,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tincidunt at felis sit amet cursus.'
        },
        {
          name: 'Admin',
          id: 2,
          description: null
        },
        {
          name: 'Usuário Corporativo',
          id: 3,
          description: null
        },
        {
          name: 'Admin de Relatórios',
          id: 4,
          description: null
        },
        {
          name: 'Admin Financeiro',
          id: 5,
          description: null
        },
        {
          name: 'Usuário de Relatórios',
          id: 6,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tincidunt at felis sit amet cursus.'
        },
        {
          name: 'Usuário Colaborador',
          id: 7,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tincidunt at felis sit amet cursus.'
        },
        {
          name: 'Usuário Supervisor',
          id: 8,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tincidunt at felis sit amet cursus.'
        },
        {
          name: 'Usuário Financeiro',
          id: 9,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tincidunt at felis sit amet cursus.'
        }
      ]
    }
  },
  methods: {
    openDrawer () {
      this.drawer = true
    },

    closeDrawer () {
      this.drawer = false
    }
  }
}
</script>
